if (!window.ddFooterSystem) {
  class DDFooterController {
    constructor(root) {
      this.root = root;
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      this.menus = Array.from(this.root.querySelectorAll('.dd-footer__menu'));
      this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
      this.wasDesktop = this.desktopQuery.matches;

      this.syncMenuState();
      this.desktopQuery.addEventListener('change', this.handleBreakpointChange);
    }

    destroy() {
      this.desktopQuery.removeEventListener('change', this.handleBreakpointChange);
    }

    handleBreakpointChange(event) {
      const isDesktop = event.matches;

      if (isDesktop !== this.wasDesktop) {
        this.wasDesktop = isDesktop;
        this.syncMenuState();
      }
    }

    syncMenuState() {
      this.menus.forEach((menu) => {
        if (this.desktopQuery.matches) {
          menu.setAttribute('open', '');
        } else {
          menu.removeAttribute('open');
        }
      });
    }
  }

  const initialiseFooter = (root = document) => {
    root.querySelectorAll('[data-dd-footer]').forEach((footer) => {
      if (!footer.ddController) footer.ddController = new DDFooterController(footer);
    });
  };

  initialiseFooter();
  document.addEventListener('shopify:section:load', (event) => initialiseFooter(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-dd-footer]').forEach((footer) => footer.ddController?.destroy());
  });
  window.ddFooterSystem = true;
}
